import styled from 'styled-components'

// Shared Dashboard Styles
export const DashboardContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  padding: 20px 0;
`

export const WidgetCard = styled.div`
  background: white;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 15px 20px;
  min-height: 300px;
  overflow: visible;
`

export const WidgetTitle = styled.h3`
  color: #a0522d;
  font-size: 16px !important;
  font-weight: 500;
  margin: 0 0 15px 0;
  border-bottom: none;
`

export const YearMonthSelector = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-bottom: 10px;
`

export const ChartHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`
